import { AuthLayout } from "@/components/auth/AuthLayout"
import { AuthShell } from "@/components/auth/AuthShell"

export function AuthScreen() {
  return (
    <AuthLayout>
      <AuthShell />
    </AuthLayout>
  )
}
